export const it = {
  // Common
  "common.back": "Indietro",
  "common.cancel": "Annulla",
  "common.noItems": "Nessun elemento",
  "common.loading": "Caricamento...",
  
  // Header
  "nav.features": "Caratteristiche",
  "nav.howItWorks": "Come Funziona",
  "nav.pricing": "Prezzi",
  "nav.faq": "FAQ",
  "nav.testimonials": "Vetrina",
  "nav.contact": "Contatti",
  "button.getStarted": "Inizia",
  "button.loading": "Caricamento...",

  // Auth related
  "auth.signIn": "Accedi",
  "auth.redirecting": "Reindirizzamento...",
  "auth.continueWithGoogle": "Continua con Google",
  "auth.continueWithGithub": "Continua con GitHub",
  "auth.or": "OPPURE",
  "auth.consent.prefix": "Continuando, accetti i nostri",
  "auth.consent.terms": "Termini",
  "auth.consent.and": "e",
  "auth.consent.privacy": "Informativa Privacy",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "Assistente di Comunicazione AI",
  "hero.subtitle": "Trasforma le tue conversazioni con risposte intelligenti e consapevoli del contesto che ti aiutano a comunicare più efficacemente in ogni situazione.",
  "hero.cta.primary": "Prova Gratuita",
  "hero.cta.secondary": "Guarda Demo",
  "hero.cta.tryNow": "Inizia Gratis",
  "hero.cta.learnMore": "Scopri di Più",
  "hero.cta.getStarted": "Inizia Gratis",
  "hero.preview.primary": "Perfeziona il Tono",
  "hero.preview.secondary": "Traduci",
  "hero.preview.tone": "Amichevole",
  "hero.preview.target": "Cliente",
  "hero.hook": "Unisciti a migliaia di utenti che migliorano la loro comunicazione ogni giorno.",
  "hero.headline": "Assistente di Comunicazione AI",
  "hero.subheadline": "Trasforma idee grezze in risposte raffinate e contestualizzate in pochi secondi.",
  
  // Stats
  "stats.users": "Utenti",
  "stats.replies": "Risposte",
  "stats.languages": "Lingue",

  // Main Title
  "main.title": "Trasforma Ogni Risposta in un'Opportunità",

  // Footer Section
  "footer.company": "Azienda",
  "footer.product": "Prodotto",
  "footer.support": "Supporto",
  "footer.legal": "Legale",
  "footer.contactSupport": "Contatta Supporto",
  "footer.helpCenter": "Centro Assistenza",
  "footer.apiDocs": "Documentazione API",
  "footer.statusPage": "Pagina Stato",
  "footer.privacyPolicy": "Informativa Privacy",
  "footer.termsOfService": "Termini di Servizio",
  "footer.cookiePolicy": "Politica Cookie",
  "footer.refundPolicy": "Politica Rimborsi",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Supporto",

  // Features Section
  "features.badge": "Caratteristiche Potenti",
  "features.title": "Tutto Ciò di cui Hai Bisogno per una Migliore Comunicazione",
  "features.subtitle": "Strumenti completi progettati per rendere ogni conversazione più efficace e professionale.",
  "features.scenario.title": "Template di Scenari",
  "features.scenario.description": "Template pre-costruiti per comunicazioni lavorative, personali, accademiche e professionali.",
  "features.custom.title": "Input Personalizzati",
  "features.custom.description": "Incolla qualsiasi messaggio o contenuto e ottieni risposte contestualmente appropriate.",
  "features.instant.title": "Riduci il tempo di risposta del 90%",
  "features.instant.description": "Ottieni risposte create dall'AI in pochi secondi. Nessuna attesa, solo risultati.",
  "features.copy.title": "Copia e Condividi con Un Click",
  "features.copy.description": "Copia le risposte istantaneamente o condividile direttamente dalla piattaforma.",

  // How It Works Section
  "howItWorks.badge": "Come Funziona",
  "howItWorks.title": "Tre Semplici Passaggi per una Migliore Comunicazione",
  "howItWorks.subtitle": "Il nostro processo semplificato rende facile generare risposte professionali per qualsiasi situazione.",
  "howItWorks.step1.title": "Seleziona Scenario",
  "howItWorks.step1.description": "Scegli lo scenario di comunicazione che meglio si adatta alle tue esigenze.",
  "howItWorks.step2.title": "Incolla Contenuto",
  "howItWorks.step2.description": "Aggiungi il messaggio o contenuto a cui devi rispondere.",
  "howItWorks.step3.title": "Ottieni Risposta AI",
  "howItWorks.step3.description": "Ricevi una risposta professionale e contestuale in secondi.",

  // Pricing Section
  "pricing.title": "Prezzi",
  "pricing.subtitle": "Scegli il piano che si adatta alle tue esigenze di comunicazione",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/mese",
  "pricing.free.description": "Perfetto per provare il nostro servizio",
  "pricing.pro.description": "Ideale per professionisti e utenti frequenti",
  "pricing.business.description": "Per team e organizzazioni",
  "pricing.popular": "Più Popolare",
  "pricing.free.feature1": "10 risposte al mese",
  "pricing.free.feature2": "Scenario base",
  "pricing.free.feature3": "Definisci e usa template",
  "pricing.free.feature4": "Cronologia risposte",
  "pricing.pro.feature1": "200 risposte al mese",
  "pricing.pro.feature2": "Scenario base+personalizzato",
  "pricing.pro.feature3": "Definisci e usa template",
  "pricing.pro.feature4": "Cronologia risposte",
  "pricing.pro.feature5": "Personalizzazione avanzata",
  "pricing.business.feature1": "Risposte illimitate",
  "pricing.business.feature2": "Collaborazione team",
  "pricing.business.feature3": "Scenario base+personalizzato",
  "pricing.business.feature4": "Definisci e usa template",
  "pricing.business.feature5": "Cronologia risposte",
  "pricing.business.feature6": "Personalizzazione avanzata",
  "pricing.cta.trial": "Inizia Prova Gratuita",
  "pricing.cta.subscribe": "Iscriviti",
  "pricing.cta.contact": "Contatta Vendite",
  "pricing.cta.current": "Piano Attuale",
  "pricing.currentPlan": "Piano Attuale:",
  "pricing.endDate": "Data fine piano attuale:",
  "pricing.autoRenewalDate": "Data rinnovo automatico piano attuale:",
  "pricing.answersLeft": "Risposte rimanenti:",
  "pricing.planName.free": "Piano Free",
  "pricing.planName.proMonthly": "Piano Pro-Mensile",
  "pricing.planName.proYearly": "Piano Pro-Annuale",
  "pricing.planName.maxMonthly": "Piano Enterprise-Mensile",
  "pricing.planName.maxYearly": "Piano Enterprise-Annuale",
  "pricing.autoRenews": "Il conteggio delle tue risposte si rinnova automaticamente il:",
  "pricing.needMore": "Serve più risposte?",
  "pricing.upgradeBelow": "Aggiorna il tuo piano qui sotto",
  "pricing.doNotRollOver": "Le risposte non utilizzate non si accumulano",
  "pricing.willCancelOn": "Verrà cancellato il:",
  "pricing.downgradeScheduled": "Downgrade programmato. Passerà a",
  "pricing.on": "il:",
  "pricing.upgradeImmediateTitle": "Piano Aggiornato",
  "pricing.upgradeImmediateDesc": "Il tuo nuovo piano è ora attivo.",
  "pricing.downgradeScheduledTitle": "Downgrade Programmato",
  "pricing.downgradeScheduledDesc": "Il tuo piano cambierà al prossimo rinnovo.",
  "pricing.cancelScheduledTitle": "Cancellazione Programmata",
  "pricing.cancelScheduledDesc": "Il tuo piano terminerà alla fine del periodo.",
  "pricing.cancelResumedTitle": "Cancellazione Rimossa",
  "pricing.cancelResumedDesc": "Il tuo abbonamento continuerà a rinnovarsi.",
  "pricing.cancelPendingDowngrade": "Annulla",
  "pricing.pendingDowngradeCanceledTitle": "Downgrade in Sospeso Annullato",
  "pricing.pendingDowngradeCanceledDesc": "Il tuo piano rimarrà invariato.",
  "pricing.pendingDowngradeCancelFailedTitle": "Annullamento Fallito",
  "pricing.pendingDowngradeCancelFailedDesc": "Impossibile annullare il downgrade in sospeso. Riprova.",
  "pricing.cancelPendingDowngradeProcessing": "Elaborazione...",
  "pricing.scheduled": "Programmato",
  "pricing.processing": "Elaborazione...",
  "pricing.getMoreReplies": "Ottieni Più Risposte",
  "pricing.oneTimeTitle": "Ottieni più risposte per il tuo account",
  "pricing.oneTimeAmountLabel": "Importo (USD)",
  "pricing.repliesUnit": "Risposte",
  "pricing.oneTimeNotice": "Il numero di risposte acquistate è valido per l'attuale ciclo mensile. È necessario un abbonamento a pagamento attivo per utilizzarle e le risposte non utilizzate non si accumulano.",
  "pricing.cancel": "Annulla",
  "pricing.proceed": "Procedi",
  "pricing.confirmUpgradeTitle": "Conferma Aggiornamento",
  "pricing.confirmDowngradeTitle": "Conferma Downgrade",
  "pricing.confirmUpgradeDesc": "Stai per aggiornare il tuo piano. La modifica avrà effetto immediato e potrebbero essere applicati costi (o crediti) proporzionali.",
  "pricing.confirmDowngradeDesc": "Stai per programmare un downgrade. Le tue funzionalità attuali rimarranno valide fino alla fine del periodo di fatturazione corrente.",
  "pricing.downgradeEffectNote": "Il downgrade non rimborsa il ciclo corrente.",
  "pricing.downgradeApplyNextCycle": "Il nuovo piano inizierà automaticamente al rinnovo.",
  "pricing.confirmCancel": "Indietro",
  "pricing.confirmProceedUpgrade": "Aggiorna Ora",
  "pricing.confirmProceedDowngrade": "Programma Downgrade",

  // FAQ Section
  "faq.title": "Domande Frequenti",
  "faq.subtitle": "Tutto quello che devi sapere su communicate2win",
  "faq.q1": "Quali scenari di comunicazione sono supportati?",
  "faq.a1": "Supportiamo comunicazioni lavorative, relazioni personali, corrispondenza accademica, servizio clienti, outreach vendite e molti altri scenari. La nostra AI si adatta al contesto e tono richiesti per ogni situazione.",
  "faq.q2": "Quanto velocemente vengono generate le risposte?",
  "faq.a2": "La nostra AI genera risposte in pochi secondi. Diamo priorità alla velocità senza compromettere la qualità, assicurando che tu ottenga risposte professionali istantaneamente.",
  "faq.q3": "Posso cancellare il mio abbonamento in qualsiasi momento?",
  "faq.a3": "Sì, puoi cancellare il tuo abbonamento in qualsiasi momento. Non ci sono impegni a lungo termine e puoi declassare o aggiornare il tuo piano secondo necessità.",
  "faq.q4": "I miei dati sono sicuri e privati?",
  "faq.a4": "Sì, implementiamo misure di sicurezza complete inclusi crittografia, controlli di accesso e audit di sicurezza regolari. Il tuo contenuto di input e le risposte generate sono memorizzate come parte della tua cronologia utente per abilitare funzionalità come revisione risposte e creazione template. Puoi eliminare i tuoi dati cronologia in qualsiasi momento tramite le impostazioni account.",
  "faq.q5": "Cosa succede se esaurisco le Replies?",
  "faq.a5": "Gli utenti Free devono attendere il ciclo mensile successivo per il rinnovo della quota. Dopo l'upgrade a Pro, se esaurisci le Replies puoi acquistare pacchetti aggiuntivi una tantum; queste Replies extra sono valide solo per l'attuale ciclo mensile. Gli utenti Enterprise hanno Replies illimitate.",
  "faq.q6": "Quali lingue sono supportate?",
  "faq.a6": "Attualmente supportiamo l'inglese con piani di espansione a spagnolo, francese, tedesco e altre lingue principali. L'AI può gestire comunicazioni multilingue efficacemente.",

  // Testimonials Section
  "testimonials.title": "Vetrina Comunicazioni",
  "testimonials.subtitle": "Messaggi pubblici, email e risposte perfezionate dall'AI per ispirare le tue",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Direttore Marketing",
  "testimonials.sarah.quote": "communicate2win ha trasformato come gestisco le comunicazioni clienti. Le risposte sono professionali e mi fanno risparmiare ore ogni settimana.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Manager Vendite",
  "testimonials.michael.quote": "I template di scenario lavorativo sono incredibilmente accurati. Il mio tasso di risposta è migliorato del 40% da quando uso questo strumento.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Lead Successo Cliente",
  "testimonials.emily.quote": "Perfetto per gestire situazioni clienti difficili. L'AI capisce perfettamente contesto e tono.",
  "testimonials.more": "Clicca sulla galleria per esplorare la vetrina completa",

  // Interface Elements
  "interface.generating": "Generando Risposta...",
  "interface.generate": "Genera Risposta AI",
  "interface.processing": "Elaborazione...",
  "interface.advancedOptions": "Opzioni Avanzate",
  "interface.clearInput": "Cancella Input",
  "interface.clearDescription": "Cancella Descrizione",
  // Marquee / Logos
  "marquee.trusted": "Partner / Supporto",
  "marquee.aria": "Loghi dei marchi",

  // History and Showcase
  "history.shareToShowcase": "Condividi in Vetrina",
  "history.showcased": "In vetrina",
  "history.shareConfirm": "Condividere questo post nella Vetrina? Questa azione non può essere annullata a meno che non elimini il post.",
  "history.sharedBy": "Condiviso da:",
  "interface.copy": "Copia",
  "interface.share": "Condividi",
  "interface.shareResponse": "Condividi Risposta",
  "interface.shareNative": "Condividi via Sistema",
  "interface.shareEmail": "Email",
  "interface.copyShareText": "Copia con Link",
  "interface.shareTextCopied": "Risposta e link copiati negli appunti.",
  "interface.ready": "Pronto a Generare",
  "interface.enterMessage": "Inserisci il contenuto del tuo messaggio e seleziona uno scenario per iniziare con risposte alimentate dall'AI.",
  "interface.fast": "Veloce",
  "interface.accurate": "Preciso",
  "interface.professional": "Professionale",
  "interface.translation": "Traduzione",
  "interface.responseDescription": "Ecco una risposta ponderata e professionale adattata al contesto:",
  "interface.multipleOptions": "Opzioni di risposta multiple:",
  "interface.option": "Opzione",
  "interface.noContent": "Nessun contenuto disponibile",

  // Placeholders
  "placeholder.message": "Incolla il messaggio a cui stai rispondendo, contenuto email o testo che hai ricevuto...",

  // Dropdowns
  "dropdown.useTemplates": "Usa Template",
  "dropdown.scenario": "Nessuno Scenario",
  "dropdown.target": "Nessun Target",
  "dropdown.tone": "Nessun Tono",

  // Scenario Options
  "scenario.email": "Email",
  "scenario.message": "Messaggio",
  "scenario.workplace": "Lavoro",
  "scenario.school": "Scuola",
  "scenario.home": "Casa",
  "scenario.business": "Business",
  "scenario.academic": "Accademico",
  "scenario.social": "Sociale",
  "scenario.formal": "Formale",
  "scenario.casual": "Informale",
  "scenario.professional": "Professionale",
  "scenario.personal": "Personale",
  "scenario.customerService": "Servizio Clienti",
  "scenario.interview": "Colloquio",
  "scenario.presentation": "Presentazione",

  // Target Options
  "target.lover": "Partner",
  "target.friend": "Amico",
  "target.boss": "Capo",
  "target.colleague": "Collega",
  "target.classmate": "Compagno di classe",
  "target.parents": "Genitori",
  "target.child": "Figlio",
  "target.teacher": "Insegnante",
  "target.student": "Studente",
  "target.client": "Cliente",
  "target.customer": "Cliente",
  "target.stranger": "Sconosciuto",
  "target.family": "Famiglia",
  "target.sibling": "Fratello/Sorella",
  "target.neighbor": "Vicino",
  "target.mentor": "Mentore",
  "target.supplier": "Fornitore",
  "target.serviceProvider": "Fornitore Servizi",
  "target.partner": "Partner",
  "target.subordinate": "Subordinato",

  // Tone Options
  "tone.humorous": "Umoristico",
  "tone.serious": "Serio",
  "tone.happy": "Felice",
  "tone.angry": "Arrabbiato",
  "tone.mischievous": "Birichino",
  "tone.polite": "Educato",
  "tone.casual": "Informale",
  "tone.formal": "Formale",
  "tone.friendly": "Amichevole",
  "tone.confident": "Sicuro",
  "tone.apologetic": "Scusante",
  "tone.enthusiastic": "Entusiasta",

  // Status Messages
  "status.copied": "Copiato!",
  "status.copyDescription": "Risposta copiata negli appunti.",
  "status.copyWithTranslationDescription": "Risposta e traduzione copiate negli appunti.",
  "status.success": "Risposta generata con successo. ",
  "status.successWithTranslation": "Risposta generata con traduzione.",
  "status.successWithoutTranslation": "Risposta generata con successo.",
  "status.error": "Generazione fallita",
  "status.errorDescription": "Impossibile generare risposta. Riprova.",
  "status.enterContent": "Inserisci contenuto",
  "status.enterContentDescription": "Aggiungi il messaggio a cui vuoi rispondere.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Descrizione (opzionale)",
  "restriction.descriptionLabel": "Descrizione (Solo per abbonati Pro / Enterprise)",
  "restriction.proMaxOnly": "* Solo per abbonati Pro / Enterprise",
  "restriction.desPrompt": "Inserisci contesto, informazioni di background o requisiti specifici che possono aiutare a generare risposte migliori...",

  // Demo functionality for non-logged-in users
  "demo.title": "Seleziona un messaggio a cui rispondere",
  "demo.option1": "Apertura vendite (approccio a freddo)",
  "demo.option2": "Gestire una domanda \"il vostro prezzo è alto\"",
  "demo.option3": "Autopresentazione colloquio (versione 30 secondi)",
  "demo.option4": "Risposta email",
  "demo.option5": "Follow-up per un prospect \"letto-ma-nessuna-risposta\"",
  "demo.option6": "Elevator pitch (30 secondi)",
  "demo.runDemo": "Esegui Demo",
  "demo.inputContent": "Contenuto Input:",
  "demo.scenario": "Scenario:",
  "demo.target": "Target:",
  "demo.tone": "Tono:",
  "demo.description": "Descrizione:",

  // Showcase Page
  "showcase.title": "Vetrina Comunicazioni",
  "showcase.subtitle": "Scopri comunicazioni ispiratrici basate sull'AI condivise dalla nostra community",
  "showcase.userPrefix": "Comunicazione pubblica di",
  "showcase.backAll": "Torna a Tutte le Vetrine",
  "showcase.sortBy": "Ordina per:",
  "showcase.sort.newest": "Prima i più recenti",
  "showcase.sort.oldest": "Prima i più vecchi",
  "showcase.sort.scenario": "Per Scenario",
  "showcase.sort.target": "Per Target",
  "showcase.sort.tone": "Per Tono",
  "showcase.filter.scenario": "Scenario:",
  "showcase.filter.target": "Target:",
  "showcase.filter.tone": "Tono:",
  "showcase.filter.all": "Tutti",
  "showcase.loading": "Caricamento vetrina...",
  "showcase.loadingUser": "Caricamento comunicazioni utente...",
  "showcase.loadingMore": "Caricamento in corso...",
  "showcase.none.userTitle": "Ancora nessuna comunicazione pubblica",
  "showcase.none.globalTitle": "Ancora nessun elemento in vetrina",
  "showcase.none.userDesc": "Questo utente non ha ancora condiviso comunicazioni nella vetrina.",
  "showcase.none.globalDesc": "Diventa il primo a condividere la tua comunicazione AI nella vetrina!",
  "showcase.messageDetails": "Dettagli Messaggio",
  "showcase.field.date": "Data",
  "showcase.field.scenario": "Scenario",
  "showcase.field.target": "Target",
  "showcase.field.tone": "Tono",
  "showcase.originalMessage": "Messaggio Originale",
  "showcase.description": "Descrizione",
  "showcase.aiResponse": "Risposta AI",

  // Templates
  "templates.saveAsTemplate": "Salva come Template",
  "templates.saved": "Template Salvato",
  "templates.saveSuccess": "Template salvato con successo",
  "templates.title": "I Miei Template",
  "templates.new": "Nuovo Template",
  "templates.loading": "Caricamento...",
  "templates.none": "Nessun template trovato",
  "templates.name": "Nome",
  "templates.scenario": "Scenario",
  "templates.target": "Target",
  "templates.tone": "Tono",
  "templates.description": "Descrizione",
  "templates.save": "Salva",
  "templates.saving": "Salvataggio...",
  "templates.delete": "Elimina Template",
  "templates.deleteConfirm": "Eliminare questo template?",
  "templates.deleteFailed": "Eliminazione template fallita",
  "templates.nameRequired": "* Inserisci il nome del template",
  "templates.deleteSuccess": "Template eliminato con successo",

  // History Modal additions
  "history.messageDetails": "Dettagli Messaggio",
  "history.messageDetailsDesc": "Visualizza e gestisci i dettagli del messaggio, inclusi input originale e risposta AI generata.",
  "history.field.date": "Data",
  "history.field.scenario": "Scenario",
  "history.field.target": "Target",
  "history.field.tone": "Tono",
  "history.originalMessage": "Messaggio Originale",
  "history.aiResponse": "Risposta AI",
  "history.description": "Descrizione",
  "history.listTitle": "Cronologia Messaggi",
  "history.listDesc": "Sfoglia, filtra e gestisci la cronologia delle tue conversazioni. Clicca su qualsiasi messaggio per visualizzarne i dettagli.",
  "history.sortBy": "Ordina per:",
  "history.sort.newest": "Prima i più recenti",
  "history.sort.oldest": "Prima i più vecchi",
  "history.sort.scenario": "Per Scenario",
  "history.sort.target": "Per Target",
  "history.sort.tone": "Per Tono",
  "history.filter.scenario": "Scenario:",
  "history.filter.target": "Target:",
  "history.filter.tone": "Tono:",
  "history.filter.all": "Tutti",
  "history.loading": "Caricamento cronologia...",
  "history.loadingMore": "Caricamento in corso...",
  "history.none": "Nessun messaggio trovato",
  "history.showing": "Visualizzazione {current} di {total} messaggi",
  "history.allLoaded": "Tutti i messaggi caricati",
  "history.scrollMore": "Scorri verso il basso per altro",
  "history.loadMoreButton": "Carica Altro",
  "history.deleteMessage": "Elimina Messaggio",
  "history.deleting": "Eliminazione...",
  "history.deleteSuccess": "Record messaggio eliminato con successo",
  "history.deleteFailed": "Eliminazione record messaggio fallita, riprova",
  "history.confirmDeleteTitle": "Conferma Eliminazione",
  "history.confirmDeleteSubtitle": "Questa azione non può essere annullata",
  "history.confirmDeleteDesc": "Sei sicuro di voler eliminare questo record messaggio?",
  "history.confirmDeleteAction": "Conferma Eliminazione",
  "history.shareTitle": "Condividi in Vetrina",
  "history.shareSubtitle": "Rendi pubblico questo messaggio",
  "history.sharing": "Condivisione...",
  "history.confirmShareAction": "Conferma Condivisione",
  "history.shareSuccess": "Messaggio condiviso con successo nella vetrina",
  "history.shareFailed": "Condivisione nella vetrina fallita, riprova",
  "templates.saveFailed": "Salvataggio template fallito",

  // User Menu
  "userMenu.myAccount": "Il Mio Account",
  "userMenu.history": "Cronologia",
  "userMenu.templates": "Template",
  "userMenu.signOut": "Esci",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "Anteprima Risposta AI",
  "hero.preview.scenarioLabel": "Scenario",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Apertura Vendite",
  "demo.shortTitle.priceObjection": "Obiezione Prezzo",
  "demo.shortTitle.interviewIntro": "Intro Colloquio",
  "demo.shortTitle.emailReply": "Risposta Email",
  "demo.shortTitle.followUp": "Follow-up",
  "demo.shortTitle.elevatorPitch": "Pitch Elevator",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "risposta",
  "demoTabs.inputPrompt": "PROMPT INPUT",
  "demoTabs.context": "CONTESTO",
  "demoTabs.description": "Descrizione",
  "demoTabs.generate": "Genera",
  "demoTabs.aiOutput": "OUTPUT AI",
  "demoTabs.sample": "campione",
  "demoTabs.streaming": "Streaming token...",
  "preview.section.scenarioTemplates.title": "Scenari & Template",
  "preview.section.scenarioTemplates.subtitle": "Scegli rapidamente uno scenario o applica un template salvato. I template precompilano descrizione/target/tono così puoi entrare immediatamente nella generazione di alta qualità.",
  "preview.section.customInputs.title": "Input Personalizzati",
  "preview.section.customInputs.subtitle": "Input principale + descrizione opzionale + selettori avanzati Scenario/Target/Tono. Combina liberamente per risultati contestuali.",
  "preview.section.cutReplyTime.title": "Riduci il Tempo di Risposta del 90%",
  "preview.section.cutReplyTime.subtitle": "Confronta la stesura manuale vs assistenza AI. Opzioni parallele + cicli di traduzione o revisione integrati.",
  "preview.section.copyShare.title": "Copia & Condividi con Un Click",
  "preview.section.copyShare.subtitle": "Opzioni multiple disposte con azioni superiori unificate: copia tutto / condividi / copia per opzione. La traduzione viene allegata automaticamente.",
  "preview.templates.my": "I Miei Template",
  "preview.templates.new": "Nuovo",
  "preview.manualFlow": "Flusso Manuale",
  "preview.aiAssisted": "Assistito da AI",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Pianifica struttura & tono",
  "preview.manualFlow.step2": "Bozza apertura / cancella & riscrivi",
  "preview.manualFlow.step3": "Regola cortesia & grammatica",
  "preview.manualFlow.step4": "Cerca lessico + verifica traduzione",
  "preview.manualFlow.step5": "Incolla nell'app target",
  "preview.copyAll": "Copia Tutto",
  "preview.share": "Condividi",
  "preview.enPlusTranslation": "EN + Traduzione",
  "preview.translationAppendNote": "(*) La traduzione viene allegata automaticamente quando si copia tutto.",
  "preview.field.scenario": "Scenario",
  "preview.field.target": "Target",
  "preview.field.tone": "Tono",
  "preview.auto": "Automatico",
  "preview.step.pasteOrTemplate": "Incolla richiesta o scegli template",
  "preview.step.optionalDescription": "(Opzionale) aggiungi descrizione/scenario",
  "preview.step.pickOption": "Scegli una delle opzioni generate",
  "preview.step.copyShareTranslate": "Copia/condividi/traduci con un click",
  "preview.time.manual": "5–8 minuti",
  "preview.time.ai": "30–40 secondi"
};